/* ============================================================
   KISANA READ MORE — Stabil åben/luk (rolldown/rollup)
   ------------------------------------------------------------
   - Lukket: tekst klampes (data-clamp, default 260px)
   - Åben:   fuld tekst vises
   - Rollup: fold tekst sammen igen
   - Samler afkortet sætning (fjerner … og indsætter fortsættelse)
   - Kun knappen centreres/stylet (ikke brødteksten)
   ============================================================ */

(function () {
  var MIN_VISIBLE_CHARS = 80; // min. brødtekst før knappen

  function textLen(el) {
    return (el.textContent || "").replace(/\s+/g, " ").trim().length;
  }

  function lastTextNode(el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var last = null, n;
    while ((n = w.nextNode())) last = n;
    return last;
  }

  function trimToClamp(content, clampPx) {
    var tn = lastTextNode(content);
    if (!tn) return "";
    var full = tn.textContent;
    var lo = 0, hi = full.length, best = 0;
    while (lo <= hi) {
      var mid = (lo + hi) >> 1;
      tn.textContent = full.slice(0, mid) + "…";
      if (content.scrollHeight <= clampPx) { best = mid; lo = mid + 1; }
      else { hi = mid - 1; }
    }
    var rest = full.slice(best);
    tn.textContent = full.slice(0, best) + (best < full.length ? "…" : "");
    return rest;
  }

  function moveOverflowToExtra(content, extra, clampPx) {
    var changed = false;
    var tooTall = function () { return content.scrollHeight > clampPx; };

    // Flyt hele noder, så toppen bevares
    while (tooTall() && content.childNodes.length > 1) {
      extra.insertBefore(content.lastChild, extra.firstChild);
      changed = true;
    }
    // Stadig for højt? Skær sidste tekstnode og læg fortsættelse i extra
    if (tooTall() && content.childNodes.length === 1) {
      var leftover = trimToClamp(content, clampPx);
      if (leftover && leftover.trim().length) {
        extra.insertBefore(document.createTextNode(leftover), extra.firstChild);
        changed = true;
      }
    }
    return changed;
  }

  function ensureMinSummary(content, extra, clampPx) {
    if (textLen(content) >= MIN_VISIBLE_CHARS) return;
    if (!extra.firstChild) return;
    content.appendChild(extra.firstChild);
    if (content.scrollHeight > clampPx) {
      var rest = trimToClamp(content, clampPx);
      if (rest && rest.trim().length) {
        extra.insertBefore(document.createTextNode(rest), extra.firstChild);
      }
    }
  }

  // --- NYT: Saml sætning ved åbning (fjern … og flet første extra-tekst ind) ---
  function mergeEllipsisWithFirstExtra(content, extra) {
    var tn = lastTextNode(content);
    if (!tn) return;

    var t = tn.textContent;
    // Find og fjern trailing ellipsis (… eller tre punktummer)
    if (!/[.…]\s*$/.test(t)) return;

    t = t.replace(/[.…]\s*$/, ""); // fjern ellipsis/dots

    // Tag første node fra extra, hvis den er tekst (eller element med kun tekst)
    var first = extra.firstChild;
    if (!first) { tn.textContent = t; return; }

    if (first.nodeType === Node.TEXT_NODE) {
      tn.textContent = t + first.textContent;
      extra.removeChild(first);
      return;
    }

    if (first.nodeType === Node.ELEMENT_NODE) {
      // Hvis elementet kun indeholder en tekstnode, kan vi flette sikkert
      if (first.childNodes.length === 1 && first.firstChild.nodeType === Node.TEXT_NODE) {
        tn.textContent = t + first.firstChild.textContent;
        extra.removeChild(first);
      } else {
        // Ellers: blot fjern ellipsis – resten appendes normalt senere
        tn.textContent = t;
      }
      return;
    }

    // fallback
    tn.textContent = t;
  }

  /* ---- Kun knappen centreres og styles ---- */
  function styleButton(toggle) {
    toggle.style.all = "unset";
    toggle.style.display = "block";
    toggle.style.margin = "1.25rem auto 0"; // kun knappen centreres
    toggle.style.padding = "0.75rem 1.5rem";
    toggle.style.backgroundColor = "#3C4E47"; // KISANA grøn
    toggle.style.color = "#ffffff";           // hvid tekst
    toggle.style.borderRadius = "999px";
    toggle.style.fontFamily = "inherit";
    toggle.style.fontSize = "1rem";
    toggle.style.fontWeight = "600";
    toggle.style.lineHeight = "1.2";
    toggle.style.textAlign = "center";
    toggle.style.cursor = "pointer";
    toggle.style.transition = "background-color .2s ease, transform .15s ease";
    toggle.style.position = "relative";
    toggle.style.zIndex = "3";

    // Hover og klik-effekter
    toggle.addEventListener("mouseenter", function () {
      toggle.style.backgroundColor = "#2F3C37";
      toggle.style.transform = "translateY(-1px)";
    });
    toggle.addEventListener("mouseleave", function () {
      toggle.style.backgroundColor = "#3C4E47";
      toggle.style.transform = "translateY(0)";
    });
    toggle.addEventListener("mousedown", function () {
      toggle.style.transform = "translateY(0)";
    });
  }

  function openSection(root, content, extra) {
    // Saml sætning: fjern … og flet første extra-tekst ind i sidste tekstnode
    mergeEllipsisWithFirstExtra(content, extra);

    // Flyt øvrigt extra-indhold tilbage i content
    while (extra.firstChild) content.appendChild(extra.firstChild);
    extra.hidden = true;

    // Smooth expand
    var startH = content.getBoundingClientRect().height;
    content.style.maxHeight = startH + "px";
    content.offsetHeight; // force reflow
    var target = content.scrollHeight;
    content.style.maxHeight = target + "px";
    setTimeout(function(){ content.style.maxHeight = "9999px"; }, 300);

    root.classList.add("is-open");
  }

  function closeSection(root, content, extra, clampPx) {
    content.style.maxHeight = "none";
    moveOverflowToExtra(content, extra, clampPx);
    ensureMinSummary(content, extra, clampPx);

    // Smooth collapse
    var startH = content.getBoundingClientRect().height;
    content.style.maxHeight = startH + "px";
    content.offsetHeight; // force reflow
    content.style.maxHeight = clampPx + "px";

    extra.hidden = true;
    root.classList.remove("is-open");
  }

  function setup(root) {
    var content = root.querySelector(".read-more__content");
    var extra   = root.querySelector(".read-more__extra");
    var toggle  = root.querySelector(".read-more__toggle");
    if (!content || !extra || !toggle) return;

    // Kun knappen centreres/stylet
    styleButton(toggle);

    var clamp = parseInt(root.getAttribute("data-clamp") || "260", 10);
    root.style.setProperty("--clamp", clamp + "px");

    // Reset: flyt alt i content for måling
    while (extra.firstChild) content.appendChild(extra.firstChild);
    extra.hidden = true;

    var prev = content.style.maxHeight;
    content.style.maxHeight = "none";

    if (content.scrollHeight <= clamp + 1) {
      toggle.hidden = true;
      content.style.maxHeight = prev || "";
      root.classList.add("is-open");
      return;
    }

    moveOverflowToExtra(content, extra, clamp);
    ensureMinSummary(content, extra, clamp);

    // Start lukket (for fade)
    content.style.maxHeight = clamp + "px";
    toggle.hidden = false;
    toggle.textContent = "Læs mere";
    toggle.setAttribute("aria-expanded", "false");
    root.classList.remove("is-open");
    root.classList.add("has-extra");
    extra.hidden = true;

    function toggleHandler(e) {
      if (e && e.type === "keydown") {
        if (!(e.key === "Enter" || e.key === " " || e.code === "Space")) return;
        e.preventDefault();
      }
      var isOpen = root.classList.contains("is-open");
      if (isOpen) {
        toggle.textContent = "Læs mere";
        toggle.setAttribute("aria-expanded", "false");
        closeSection(root, content, extra, clamp);
      } else {
        toggle.textContent = "Læs mindre";
        toggle.setAttribute("aria-expanded", "true");
        openSection(root, content, extra);
      }
    }
    toggle.addEventListener("click", toggleHandler);
    toggle.addEventListener("keydown", toggleHandler);
    toggle.setAttribute("role", "button");
    toggle.setAttribute("tabindex", "0");

    // Recalc ved resize/medieindlæsning (gælder kun når lukket)
    var schedule = null;
    function recalc() {
      if (root.classList.contains("is-open")) return;
      content.style.maxHeight = "none";
      moveOverflowToExtra(content, extra, clamp);
      ensureMinSummary(content, extra, clamp);
      content.style.maxHeight = clamp + "px";
    }
    window.addEventListener("resize", function () {
      clearTimeout(schedule);
      schedule = setTimeout(recalc, 100);
    });
    content.querySelectorAll("img").forEach(function (img) {
      img.addEventListener("load", recalc, { once: true });
    });
  }

  function initAll() {
    document.querySelectorAll(".read-more").forEach(setup);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
